enum PaginationEnum {
  perPage = 10,
}

export default PaginationEnum;
